
export enum StatusEnums {
    IDLE = "idle",
    LOADING = "loading",
    FAILED = "failed",
    SUCCESS = 'success'
}